import React from "react";
import FirebaseContext from "../../firebase/context";
import { withRouter } from 'react-router-dom';
// import distanceInWordsToNow from "date-fns/distance_in_words_to_now";
import { formatDistance, subDays } from 'date-fns'
import { Avatar, Card } from '@material-ui/core';
import punto5Avatar from '../../img/Punto5_Avatar.png';
import { makeStyles, useTheme } from '@material-ui/core/styles';



import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        // maxWidth: '36ch',
        backgroundColor: theme.palette.background.paper,
        // display: 'flex',
    },
    inline: {
        display: 'inline',
    },
    avatar: {
        margin: 2,
        width: 30,
        height: 30

    }
}));

const style = {
    container: {
        // fixed: 1,
        // disableGutters: 1,
        // paddingTop: 8,
        // paddingBottom: 8
        width: '100%',
        // flexGrow: 1,
    },
    cardGrid: {
        paddingTop: 8,
        paddingBottom: 8
    },
    paper: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
        // minHeight: 650,
        // minWidth: 650
    },
    paperMenu: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
        // minHeight: 650,
        // minWidth: 100,
        // maxWidth: 300
    },
    link: {
        display: "flex"
    },
    gridTextfield: {
        marginTop: "20px"
    },
    card: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#B5DEF1",
    },
    cardMedia: {
        paddingTop: "56.25%"
    },
    cardContent: {
        flexGrow: 1
    },
    barraBoton: {
        marginTop: "20px"
    }
};

// import LinkItem from "./LinkItem";

const CompTemaComent = (props) => {

    const classes = useStyles();

    const distanceInWordsToNow = formatDistance(subDays(new Date(), 3), new Date())
    const { firebase, user } = React.useContext(FirebaseContext);
    const [link, setLink] = React.useState(null);
    const [commentText, setCommentText] = React.useState("");
    const temaId = props.temaId
    const temaRef = firebase.db.collection("colTemas").doc(temaId);

    React.useEffect(() => {
        getLink();
    }, [temaId]);

    function getLink() {
        temaRef.get().then(doc => {
            setLink({ ...doc.data(), id: doc.id });
        });
    }

    function handleAddComment() {
        if (!user) {
            props.history.push("/login");
        } else {
            temaRef.get().then(doc => {
                if (doc.exists) {
                    const previousComments = doc.data().comments;
                    const comment = {
                        postedBy: { id: user.uid, name: user.displayName, foto: user.photoURL },
                        created: Date.now(),
                        text: commentText
                    };
                    const updatedComments = [...previousComments, comment];
                    temaRef.update({ comments: updatedComments });
                    setLink(prevState => ({
                        ...prevState,
                        comments: updatedComments
                    }));
                    setCommentText("");
                }
            });
        }
    }

    return !link ? (
        <div>Cargando...</div>
    ) : (
            <div>
                <Card style={style.card}>
                <textarea
                        onChange={event => setCommentText(event.target.value)}
                        value={commentText}
                        rows="3"
                        cols="80"
                    />
                    <div>
                        <button className="button" onClick={handleAddComment}>
                            Comentar
                    </button>
                    </div>
                <List className={classes.root}>
                    {link.comments.map((comment, index) => (
                        <div key={index}>
                            <ListItem alignItems="flex-start">
                                <ListItemAvatar>
                                    <Avatar alt="Remy Sharp" src={comment.postedBy.foto || punto5Avatar} />
                                </ListItemAvatar>
                                <ListItemText
                                    primary={comment.postedBy.name}
                                    secondary={
                                        <React.Fragment>
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                className={classes.inline}
                                                color="textPrimary"
                                            >
                                                {comment.text}
                                            </Typography>
                                            {formatDistance(Date.now(), comment.created, { addSuffix: true })}
                                        </React.Fragment>
                                    }
                                />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                        </div>
                    ))}
                </List>
                
                   

                </Card>
            </div>
        );
}

export default withRouter(CompTemaComent)
